import { render } from "./ModalOrderDetails.vue?vue&type=template&id=40a62c08"
import script from "./ModalOrderDetails.vue?vue&type=script&lang=js"
export * from "./ModalOrderDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__